/* import __COLOCATED_TEMPLATE__ from './learningmaterial-manager.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { dropTask, restartableTask } from 'ember-concurrency';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { DateTime } from 'luxon';
import { findById } from 'ilios-common/utils/array-helpers';
import YupValidations from 'ilios-common/classes/yup-validations';
import { date, string } from 'yup';
let LearningMaterialManagerComponent = (_class = class LearningMaterialManagerComponent extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "flashMessages", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _defineProperty(this, "validations", new YupValidations(this, {
      title: string().required().min(4).max(120),
      startDate: date().notRequired(),
      endDate: date().notRequired().when('startDate', {
        is: startDate => !!startDate,
        // Check if the startDate field has a value
        then: schema => schema.test('is-end-date-after-start-date', d => {
          return {
            path: d.path,
            messageKey: 'errors.after',
            values: {
              after: this.intl.t('general.startDate')
            }
          };
        }, value => {
          if (!value) {
            return true;
          }
          return DateTime.fromJSDate(value).diff(DateTime.fromJSDate(this.startDate), 'minutes') > 1;
        })
      })
    }));
    _initializerDefineProperty(this, "isLoaded", _descriptor4, this);
    _initializerDefineProperty(this, "notes", _descriptor5, this);
    _initializerDefineProperty(this, "learningMaterial", _descriptor6, this);
    _initializerDefineProperty(this, "title", _descriptor7, this);
    _initializerDefineProperty(this, "endDate", _descriptor8, this);
    _initializerDefineProperty(this, "type", _descriptor9, this);
    _initializerDefineProperty(this, "owningUser", _descriptor10, this);
    _initializerDefineProperty(this, "originalAuthor", _descriptor11, this);
    _initializerDefineProperty(this, "description", _descriptor12, this);
    _initializerDefineProperty(this, "copyrightPermission", _descriptor13, this);
    _initializerDefineProperty(this, "copyrightRationale", _descriptor14, this);
    _initializerDefineProperty(this, "citation", _descriptor15, this);
    _initializerDefineProperty(this, "link", _descriptor16, this);
    _initializerDefineProperty(this, "mimetype", _descriptor17, this);
    _initializerDefineProperty(this, "absoluteFileUri", _descriptor18, this);
    _initializerDefineProperty(this, "filename", _descriptor19, this);
    _initializerDefineProperty(this, "uploadDate", _descriptor20, this);
    _initializerDefineProperty(this, "closeManager", _descriptor21, this);
    _initializerDefineProperty(this, "terms", _descriptor22, this);
    _initializerDefineProperty(this, "startDate", _descriptor23, this);
    _initializerDefineProperty(this, "parentMaterial", _descriptor24, this);
    _initializerDefineProperty(this, "statusId", _descriptor25, this);
    _initializerDefineProperty(this, "userRoleTitle", _descriptor26, this);
    _initializerDefineProperty(this, "publicNotes", _descriptor27, this);
    _initializerDefineProperty(this, "required", _descriptor28, this);
    _defineProperty(this, "defaultTime", DateTime.fromObject({
      hour: 8,
      minute: 0,
      second: 0
    }).toJSDate());
    _defineProperty(this, "updateOtherDate", (originalDate, value) => {
      const otherDate = DateTime.fromJSDate(value);
      this[originalDate] = DateTime.fromObject({
        month: otherDate.month,
        day: otherDate.day,
        hour: 8,
        minute: 0,
        second: 0
      }).toJSDate();
    });
    _defineProperty(this, "save", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.validations.addErrorDisplayForAllFields();
        const isValid = yield this.validations.isValid();
        if (!isValid) {
          return false;
        }
        this.validations.clearErrorDisplay();
        this.args.learningMaterial.set('publicNotes', this.publicNotes);
        this.args.learningMaterial.set('required', this.required);
        this.args.learningMaterial.set('notes', this.notes);
        this.args.learningMaterial.set('startDate', this.startDate);
        this.args.learningMaterial.set('endDate', this.endDate);
        this.parentMaterial.set('status', this.currentStatus);
        this.parentMaterial.set('title', this.title);
        this.parentMaterial.set('description', this.description);
        this.args.learningMaterial.set('meshDescriptors', this.terms);
        yield this.args.learningMaterial.save();
        yield this.parentMaterial.save();
        this.args.closeManager();
      }
    }), null, "save", "drop"));
    _defineProperty(this, "textCopied", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.flashMessages.success('general.copiedSuccessfully');
      }
    }), null, "textCopied", "restartable"));
    this.loadExistingData();
  }
  get isFile() {
    return this.type === 'file';
  }
  get isLink() {
    return this.type === 'link';
  }
  get isCitation() {
    return this.type === 'citation';
  }
  updateDate(which, value) {
    const {
      hour,
      minute
    } = DateTime.fromJSDate(this[which]);
    const {
      year,
      ordinal
    } = DateTime.fromJSDate(value);
    this[which] = DateTime.fromObject({
      year,
      ordinal,
      hour,
      minute,
      second: 0
    }).toJSDate();
    if (which == 'startDate' && this['endDate']) {
      if (DateTime.fromJSDate(value) > DateTime.fromJSDate(this['endDate'])) {
        this.updateOtherDate('endDate', value);
      }
    }
    if (which == 'endDate' && this['startDate']) {
      if (DateTime.fromJSDate(value) < DateTime.fromJSDate(this['startDate'])) {
        this.updateOtherDate('startDate', value);
      }
    }
  }
  updateTime(which, value, type) {
    let {
      year,
      ordinal,
      hour,
      minute
    } = DateTime.fromJSDate(this[which]);
    if (type === 'hour') {
      hour = value;
    }
    if (type === 'minute') {
      minute = value;
    }
    this[which] = DateTime.fromObject({
      year: year,
      ordinal: ordinal,
      hour: hour,
      minute: minute,
      second: 0
    }).toJSDate();
    this.validations.addErrorDisplayFor(which);
  }
  addDate(which) {
    if (which == 'endDate') {
      if (this['startDate']) {
        this.updateOtherDate('endDate', this['startDate']);
      } else {
        this[which] = this.defaultTime;
      }
    } else {
      if (which == 'startDate') {
        if (this['endDate']) {
          this.updateOtherDate('startDate', this['endDate']);
        } else {
          this[which] = this.defaultTime;
        }
      }
    }
  }
  addTerm(term) {
    this.terms = [...this.terms, term];
  }
  removeTerm(term) {
    this.terms = this.terms.filter(obj => obj !== term);
  }
  updateStatusId(event) {
    this.statusId = event.target.value;
  }
  get courseLearningMaterialIds() {
    if (!this.parentMaterial) {
      return [];
    }
    return this.parentMaterial.hasMany('courseLearningMaterials').ids();
  }
  get sessionLearningMaterialIds() {
    if (!this.parentMaterial) {
      return [];
    }
    return this.parentMaterial.hasMany('sessionLearningMaterials').ids();
  }

  /**
   * Whether the given learning material is linked to no more than one session or course.
   */
  get isLinkedOnlyOnce() {
    return this.courseLearningMaterialIds.length + this.sessionLearningMaterialIds.length === 1;
  }
  get currentStatus() {
    return findById(this.args.learningMaterialStatuses, this.statusId);
  }
  async loadExistingData() {
    if (!this.args.learningMaterial) {
      throw new Error('LearningMaterialManagerComponent requires a learningMaterial argument');
    }
    const {
      learningMaterial
    } = this.args;
    const parentMaterial = await learningMaterial.learningMaterial;
    this.notes = learningMaterial.notes;
    this.required = learningMaterial.required;
    this.publicNotes = learningMaterial.publicNotes;
    this.startDate = learningMaterial.startDate;
    this.endDate = learningMaterial.endDate;
    this.terms = await learningMaterial.meshDescriptors;
    this.parentMaterial = parentMaterial;
    this.type = parentMaterial.type;
    this.title = parentMaterial.title;
    this.originalAuthor = parentMaterial.originalAuthor;
    this.description = parentMaterial.description;
    this.copyrightPermission = parentMaterial.copyrightPermission;
    this.copyrightRationale = parentMaterial.copyrightRationale;
    this.citation = parentMaterial.citation;
    this.link = parentMaterial.link;
    this.mimetype = parentMaterial.mimetype;
    this.absoluteFileUri = parentMaterial.absoluteFileUri;
    this.filename = parentMaterial.filename;
    this.uploadDate = parentMaterial.uploadDate;
    const status = await parentMaterial.status;
    this.statusId = status.id;
    this.owningUser = await parentMaterial.owningUser;
    const userRole = await parentMaterial.userRole;
    this.userRoleTitle = userRole.title;
    this.isLoaded = true;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isLoaded", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "notes", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "learningMaterial", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "title", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "endDate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "type", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "owningUser", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "originalAuthor", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "description", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "copyrightPermission", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "copyrightRationale", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "citation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "link", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "mimetype", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "absoluteFileUri", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "filename", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "uploadDate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "closeManager", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "terms", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "startDate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "parentMaterial", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "statusId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "userRoleTitle", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "publicNotes", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "required", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "updateDate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateTime", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addDate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addTerm", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addTerm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeTerm", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeTerm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateStatusId", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateStatusId"), _class.prototype), _class);
export { LearningMaterialManagerComponent as default };